import { Flex, Heading, Image } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { Bounce, Slide } from "react-awesome-reveal";
import { FormattedMessage } from "react-intl";
import FormAddWinner from "../../components/FormAddWinner/FormAddWinner";
import Loading from "../../components/Loading/Loading";
import { API } from "../../shared/Api/Api";
import { Context } from "../../shared/Context/Context";

const Winners = () => {
  const [winners, setWinners] = useState();
  const [loading, setLoading] = useState(false);
  const { isAdmin, tabletOrLess } = useContext(Context);

  const getWinners = async () => {
    setLoading(true);
    setWinners(await API.get("winners"));
    setLoading(false);
  };

  useEffect(() => {
    getWinners();
  }, []);

  return (
    <>
      <Flex
        w="100%"
        h="100%"
        justify="flex-start"
        align="center"
        flexDir="column"
        mt={tabletOrLess && "40px"}
        p="60px 0px 90px 0px"
        minH="87vh"
      >
        {loading ? (
          <Loading />
        ) : (
          <>
            <Flex
              p="30px"
              borderRadius="10px"
              border="3px solid #1f1235"
              backgroundColor="#ff6e6c"
              w="70%"
              justify="center"
              align="center"
              fontWeight="600"
            >
              <Bounce triggerOnce>
                <Heading
                  fontSize={tabletOrLess && "17px"}
                  textAlign="center"
                  color="#FFFFFF"
                >
                  <FormattedMessage
                    id="app.winners.heading"
                  />
                </Heading>
              </Bounce>
            </Flex>
            <Flex
              w="100%"
              justify="center"
              align="center"
              flexDir="column"
              pt="50px"
            >
              {winners && (
                <>
                  <Heading
                    border="3px solid #1f1235"
                    backgroundColor="#fbdd74"
                    color="#1f1235"
                    textAlign="center"
                    p="10px"
                    minH="70px"
                    fontSize={tabletOrLess ? "20px" : "25px"}
                    borderRadius="10px"
                    w={tabletOrLess ? "70%" : "50%"}
                  >
                    <FormattedMessage
                      id="app.winners.heading2"
                    /> {winners.data.mes}
                  </Heading>
                  <Flex
                    justify="space-between"
                    align="center"
                    w={tabletOrLess ? "70%" : "350px"}
                    mt="40px"
                  >
                    <Bounce triggerOnce >
                      <Heading fontSize={tabletOrLess ? "15px" : "20px"}>
                        <FormattedMessage
                          id="app.winners.primaria"
                        />
                      </Heading>
                    </Bounce>
                    <Bounce triggerOnce >
                      <Heading fontSize={tabletOrLess ? "15px" : "20px"}>
                        {winners.data.winnerPrimaria}
                      </Heading>
                    </Bounce>
                  </Flex>
                  <Flex
                    justify="space-between"
                    align="center"
                    w={tabletOrLess ? "80%" : "350px"}
                    mt="40px"
                  >
                    <Bounce triggerOnce >
                      <Heading fontSize={tabletOrLess ? "15px" : "20px"}>
                        <FormattedMessage
                          id="app.winners.secundaria"
                        />
                        {" "}
                      </Heading>
                    </Bounce>
                    <Bounce triggerOnce >
                      <Heading fontSize={tabletOrLess ? "15px" : "20px"}>
                        {winners.data.winnerSecundaria}
                      </Heading>
                    </Bounce>
                  </Flex>
                  {isAdmin ? (
                    <FormAddWinner winners={winners} setWinners={setWinners} />
                  ) : (
                    <Slide direction="right" triggerOnce duration="10000" >
                      <Image
                        pt="30px"
                        alt="gif gracioso"
                        src="/assets/Pocoyo.gif"
                      />
                    </Slide>
                  )}
                </>
              )}
            </Flex>
          </>
        )}
      </Flex>
    </>
  );
};

export default Winners;
